import React from "react";
import PropTypes from "prop-types";
import { Table, Divider, Input, Button, Tooltip } from "antd";
import {
  SearchOutlined,
  PlusCircleOutlined,
  CloudServerOutlined,
  MobileOutlined,
  ApartmentOutlined,
} from "@ant-design/icons";
import { StatusSwitch } from "../Common/StatusSwitch";
import {
  defaultSort,
  getTablePagesize,
  setTablePageSize,
} from "../../Constants/Utilities";
import {
  DeviceModelActions,
  DeviceModelCategory,
  StatusFilters,
  TablePages,
  TablePageSizes,
} from "../../Constants/Constants";
import { BreadCrumbs } from "../Common/BreadCrumbs";

class ListDeviceModel extends React.Component {
  constructor(props) {
    super(props);
    console.log("ListDeviceModel props", props);
    this.state = {
      deviceModelData: props.deviceModelData,
    };
  }

  getColumns = () => {
    const { onActionClick, onStatusChange } = this.props;
    return [
      {
        title: "Device Model Number",
        dataIndex: "modelNumber",
        sorter: (a, b) => defaultSort(a.modelNumber, b.modelNumber),
        defaultSortOrder: "ascend",
        render: (value, record) => (
          <Button
            type="link"
            onClick={onActionClick(DeviceModelActions.edit, record)}
          >
            {value}
          </Button>
        ),
      },
      {
        title: "Manufacturer",
        dataIndex: "manufacturer",
        sorter: (a, b) => defaultSort(a.manufacturer, b.manufacturer),
      },
      {
        title: "Active",
        dataIndex: "status",
        align: "center",
        filters: StatusFilters,
        onFilter: (value, record) => record.status === value,
        render: StatusSwitch(onStatusChange),
      },
      {
        title: "Actions",
        dataIndex: "actions",
        align: "center",
        render: (_, record) => (
          <div className="entity-list-actions">
            <Tooltip title="List Devices">
              <MobileOutlined
                className="entity-action"
                onClick={onActionClick(DeviceModelActions.listDevice, record)}
              />
            </Tooltip>
            <Tooltip title="List Service Tiers">
              <CloudServerOutlined
                className="entity-action"
                onClick={onActionClick(DeviceModelActions.listTier, record)}
              />
            </Tooltip>
            {record.category === DeviceModelCategory.primary.value ? (
              <Tooltip title="Model Dependency">
                <ApartmentOutlined
                  onClick={onActionClick(DeviceModelActions.dependency, record)}
                />
              </Tooltip>
            ) : (
              <span style={{ marginLeft: "14px" }} />
            )}
          </div>
        ),
      },
    ];
  };

  componentDidUpdate(prevProps) {
    if (prevProps.deviceModelData !== this.props.deviceModelData) {
      this.setState({ deviceModelData: this.props.deviceModelData });
    }
  }

  onSerchTextChange = (e) => {
    const text = e.target.value;
    const { deviceModelData } = this.props;
    if (!!text) {
      const filteredData = deviceModelData.filter((item) =>
        item.modelNumber.toLowerCase().includes(text.toLowerCase())
      );
      this.setState({ deviceModelData: filteredData });
      return;
    }
    this.setState({ deviceModelData });
  };

  render() {
    const { deviceModelData } = this.state;
    const { deviceModelDataLoading, onActionClick, parentBread } = this.props;

    return (
      <div className="entity-list-container">
        <div className="page-header-container">
          <BreadCrumbs headers={parentBread} />
        </div>
        <Divider className="divider" />
        <div className="search-add-container">
          <div className="search-container">
            <span className="search-label">Search:</span>
            <Input
              allowClear
              className="search-input"
              placeholder="Enter Model Number"
              onChange={this.onSerchTextChange}
              suffix={<SearchOutlined style={{ fontSize: 16 }} />}
            />
          </div>
          <div className="add-container">
            <Button
              type="primary"
              icon={<PlusCircleOutlined />}
              onClick={onActionClick(DeviceModelActions.add, null)}
            >
              Add Device Model
            </Button>
          </div>
        </div>
        <Table
          bordered
          size="small"
          columns={this.getColumns()}
          className="entity-table"
          loading={
            deviceModelDataLoading && { tip: "Fetching Device Model list..." }
          }
          dataSource={deviceModelData}
          pagination={{
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            defaultPageSize: getTablePagesize(TablePages.listDeviceModel),
            pageSizeOptions: TablePageSizes,
            onChange: (_, pageSize) =>
              setTablePageSize(TablePages.listDeviceModel, pageSize),
          }}
        />
      </div>
    );
  }
}

ListDeviceModel.propTypes = {
  deviceModelData: PropTypes.array,
  deviceModelDataLoading: PropTypes.bool,
  onActionClick: PropTypes.func,
  onStatusChange: PropTypes.func,
};

export default ListDeviceModel;
